import type { ModelsConfig } from '../types';

/**
 * @deprecated FALLBACK ONLY - не редактировать!
 * Актуальные данные приходят с бэкенда через useChatModelsConfig() хук.
 * Этот конфиг используется только как offline fallback.
 * Единый источник правды: pricing/constants/chat-registry.js
 */
export const CHAT_MODELS_CONFIG: ModelsConfig = {
  chatgpt: [
    { value: 'gpt-5.4-mini-2026-03-17', text: '5.4 Mini', tagline: 'Быстрая и доступная', supportsVision: true, requiredTier: 'free' },
    { value: 'gpt-5.4-2026-03-05', text: '5.4', tagline: 'Универсальная и сбалансированная', supportsVision: true, requiredTier: 'free' },
    { value: 'gpt-5.5-2026-04-23', text: '5.5', tagline: 'Свежий флагман OpenAI', supportsVision: true, requiredTier: 'free' },
    { value: 'gpt-5.3-codex', text: '5.3 Codex', tagline: 'Заточена под код', supportsVision: true, requiredTier: 'basic' },
    { value: 'gpt-5.5-pro-2026-04-23', text: '5.5 Pro', tagline: 'Максимум возможностей', supportsVision: true, requiredTier: 'pro' },
    { value: 'gpt-4.1-2025-04-14', text: '4.1', tagline: 'Стабильная классика', supportsVision: true, requiredTier: 'free' }
  ],
  gemini: [
    { value: 'gemini-3.1-flash-lite-preview', text: '3.1 Flash Lite', tagline: 'Самая быстрая и экономная', supportsVision: true, requiredTier: 'free' },
    { value: 'gemini-3-flash-preview', text: '3 Flash', tagline: 'Быстрая с размышлением', supportsVision: true, requiredTier: 'free' },
    { value: 'gemini-2.5-pro', text: '2.5 Pro', tagline: 'Глубокий анализ', supportsVision: true, requiredTier: 'free' },
    { value: 'gemini-3-pro-preview', text: '3 Pro', tagline: 'Топовая для сложных задач', supportsVision: true, requiredTier: 'free' },
    { value: 'gemini-3.1-pro-preview', text: '3.1 Pro', tagline: 'Свежий флагман Google', supportsVision: true, requiredTier: 'free' }
  ],
  claude: [
    { value: 'claude-haiku-4-5', text: 'Haiku 4.5', tagline: 'Быстрая и экономная', supportsVision: true, requiredTier: 'free' },
    { value: 'claude-sonnet-4-6', text: 'Sonnet 4.6', tagline: 'Баланс скорости и качества', supportsVision: true, requiredTier: 'free' },
    { value: 'claude-opus-4-7', text: 'Opus 4.7', tagline: 'Самая мощная для сложных задач', supportsVision: true, requiredTier: 'pro' }
  ],
  grok: [
    { value: 'grok-4.3', text: '4.3', tagline: 'Контекст 1M, поиск и размышление', supportsVision: true, requiredTier: 'free' }
  ],
  deepseek: [
    { value: 'deepseek-v4-flash', text: '4 Flash', tagline: 'Быстрая с размышлением', supportsVision: false, requiredTier: 'free' },
    { value: 'deepseek-v4-pro', text: '4 Pro', tagline: 'Мощная для сложных задач', supportsVision: false, requiredTier: 'free' }
  ]
};

// Конфигурация моделей для генерации изображений (обновлено для Responses API)
export const IMAGE_MODELS_CONFIG: ModelsConfig = {
  'nano-banana-2': [
    {
      value: 'gemini-3.1-flash-image-preview',
      text: 'Nano Banana 2',
      formats: ['auto', '1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
      quality: ['0.5K', '1K', '2K', '4K'], 
      count: [1], 
      maxFiles: 10,
      supportsImageToImage: true,
      supportsWorldKnowledge: true,
      supportsThinking: true,
      supportsGoogleSearch: true,
      defaultThinkingLevel: 'High',
      supportsFastMode: false,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Gemini 3.1 Flash для изображений — «думает» перед отрисовкой (Thinking High) и использует Google Search + Image Search для актуальных деталей. 4 уровня разрешения от 0.5K до 4K.',
      descriptionKey: 'models.nanoBanana2.description',
      badge: 'top'
    }
  ],
  'nano-banana-pro': [
    {
      value: 'gemini-3-pro-image-preview',
      text: 'Nano Banana Pro',
      formats: ['auto', '1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
      quality: ['1K', '2K', '4K'], 
      count: [1], 
      maxFiles: 10,
      supportsImageToImage: true,
      supportsWorldKnowledge: true,
      supportsThinking: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Флагман Google в генерации изображений — умеет «думать» перед отрисовкой и использует поиск для актуальных деталей. Работает с 10 фото одновременно. Комьюнити отмечает за сложные сцены и впечатляющую детализацию в 4K.',
      descriptionKey: 'models.nanoBananaPro.description',
      badge: 'top'
    }
  ],
  'gpt-image-2': [
    {
      value: 'gpt-image-2',
      text: 'GPT Image 2',
      formats: ['1:1', '3:2', '2:3', '4:3', '3:4', '5:4', '4:5', '16:9', '9:16', '21:9'],
      quality: ['low', 'medium', 'high'],
      resolutions: ['1K', '2K', '4K'],
      count: [1],
      maxFiles: 5,
      supportInputFidelity: false,
      supportsVision: true,
      supportsWorldKnowledge: true,
      supportsEdit: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Новейшая модель OpenAI для генерации изображений. Точнее рендерит текст, стабильнее держит композицию и поддерживает 1K/2K/4K на 10 соотношениях сторон.',
      descriptionKey: 'models.gptImage2.description',
      badge: 'top'
    }
  ],
  'gpt-image-1.5': [
    {
      value: 'gpt-image-1.5',
      text: 'GPT Image 1.5',
      formats: ['1:1', '3:2', '2:3'], // 1024x1024, 1536x1024, 1024x1536
      quality: ['low', 'medium', 'high'],
      count: [1],
      maxFiles: 5,
      supportInputFidelity: false,
      supportsVision: true,
      supportsWorldKnowledge: true,
      supportsEdit: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Один из лучших по рендеру текста на изображениях: читаемые надписи, схемы, инфографика. Понимает контекст и редактирует точечно — меняет одно, не затрагивая остальное.',
      descriptionKey: 'models.gptImage15.description',
      badge: 'transparentBg'
    }
  ],
  'nano-banana': [
    {
      value: 'gemini-image',
      text: 'Nano Banana',
      formats: ['auto', '1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
      quality: ['standard'], 
      count: [1], 
      maxFiles: 3,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Быстрая и приятная от Google — хороший выбор, когда нужен результат прямо сейчас. Поддерживает image-to-image и все популярные форматы кадра.',
      descriptionKey: 'models.nanoBanana.description',
      badges: ['top', 'fast']
    }
  ],
  'seedream-4.5': [
    { 
      value: 'seedream-4.5', 
      text: 'Seedream 4.5', 
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'], 
      quality: ['2K', '4K'], // Минимум 3,686,400 пикселей (2560x1440) - 1K не поддерживается
      count: [1], // Временно скрыт выбор количества
      maxFiles: 10,
      supportedResponseFormats: ['url', 'b64_json'],
      supportedSequentialModes: ['enabled', 'disabled'],
      defaultWatermark: true,
      supportAdvancedOptions: true,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      requiredTier: 'free',
      description: 'Выделяется при работе с несколькими референсами — сохраняет детали, свет и цвет при редактировании. Особая сила в портретах и мелком тексте на изображениях.',
      descriptionKey: 'models.seedream45.description',
      badge: 'top'
    }
  ],
  'seedream-4': [
    { 
      value: 'seedream-4', 
      text: 'Seedream 4', 
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'], 
      quality: ['1K', '2K', '4K'], 
      count: [1], // Временно скрыт выбор количества
      maxFiles: 8,
      supportedResponseFormats: ['url', 'b64_json'],
      supportedSequentialModes: ['enabled', 'disabled'],
      defaultWatermark: true,
      supportAdvancedOptions: true,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Предыдущее поколение Seedream — стабильный фотореализм и работа с до 8 референсами. Чуть уступает 4.5 в редактировании и мелком тексте, но остаётся надёжным выбором.',
      descriptionKey: 'models.seedream4.description'
    }
  ],
  'seedream-5-lite': [
    {
      value: 'seedream-5-lite',
      text: 'Seedream 5.0 Lite',
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
      quality: ['2K', '3K'],
      count: [1],
      maxFiles: 10,
      supportedResponseFormats: ['url', 'b64_json'],
      supportedSequentialModes: ['enabled', 'disabled'],
      defaultWatermark: false,
      supportAdvancedOptions: true,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      requiredTier: 'free',
      description: 'Новейшая Seedream 5.0 lite от ByteDance — универсальная мультимодальная модель с поддержкой текста, одного и нескольких изображений. Отличается гибкостью и качеством в различных сценариях.',
      descriptionKey: 'models.seedream5Lite.description',
      badge: 'top'
    }
  ],
  'grok-imagine-image-pro': [
    {
      value: 'grok-imagine-image-pro',
      text: 'Imagine Pro',
      formats: ['auto', '1:1', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '2:1', '1:2', '19.5:9', '9:19.5', '20:9', '9:20'],
      quality: ['1K', '2K'],
      count: [1, 2, 3, 4],
      maxFiles: 5,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Флагман Grok Imagine от xAI — максимум детализации и широкий диапазон стилей. Поддерживает редактирование по референсам (до 5) и многокадровые сравнения.',
      descriptionKey: 'models.grokImaginePro.description',
      badge: 'top'
    }
  ],
  'grok-imagine-image': [
    {
      value: 'grok-imagine-image',
      text: 'Imagine',
      formats: ['auto', '1:1', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '2:1', '1:2', '19.5:9', '9:19.5', '20:9', '9:20'],
      quality: ['1K', '2K'],
      count: [1, 2, 3, 4],
      maxFiles: 5,
      supportsImageToImage: true,
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Grok Imagine от xAI — быстрая и экономичная генерация с огромным набором форматов кадра. Поддерживает редактирование по референсам (до 5 изображений).',
      descriptionKey: 'models.grokImagine.description',
      badge: 'fast'
    }
  ],
  'imagen-4-fast': [
    { 
      value: 'imagen-4-fast', 
      text: 'Imagen 4 Fast', 
      formats: ['1:1', '3:4', '4:3', '9:16', '16:9'], 
      quality: ['standard'], 
      count: [1, 2, 3, 4],
      maxFiles: 0,
      description: 'В 10 раз быстрее предыдущих Imagen при хорошем качестве. Встроенный водяной знак SynthID. Для задач, где скорость важнее предельного качества.',
      descriptionKey: 'models.imagen4Fast.description',
      badges: ['top', 'fast']
    }
  ],
  'imagen-4-ultra': [
    {
      value: 'imagen-4-ultra',
      text: 'Imagen 4 Ultra',
      formats: ['1:1', '3:4', '4:3', '9:16', '16:9'],
      quality: ['1K', '2K'],
      count: [1, 2, 3, 4],
      maxFiles: 0,
      description: 'Лучшее качество и следование промпту в линейке Imagen. Заметно улучшенный рендер текста — один из лидеров в категории среди моделей Google.',
      descriptionKey: 'models.imagen4Ultra.description'
    }
  ],
  'higgsfield-soul': [
    { 
      value: 'higgsfield-soul', 
      text: 'Higgsfield Soul', 
      formats: [
        '9:16', '3:4', '2:3', '1:1', '3:2', '4:3', '16:9'
      ], 
      quality: ['Basic', 'High'], // Basic (720p) доступен с Free, High (1080p) - с Basic подписки
      count: [1, 4], // Higgsfield batch_size: 1 или 4
      maxFiles: 1, // Поддерживает 1 image_reference для image-to-image
      supportsImageToImage: true,
      supportsHiggsfieldStyles: true, // Поддержка Soul Styles
      supportsCharacterConsistency: true, // Поддержка Soul ID (custom_reference_id)
      supportsEnhancePrompt: true, // Поддержка enhance_prompt
      description: 'Фэшн-уровень портретной фотографии с 50+ готовыми эстетиками. Soul ID сохраняет внешность персонажа — нужно 20+ референсных фото для обучения. Для серьёзной фотоработы.',
      descriptionKey: 'models.higgsfieldSoul.description',
      badge: 'top'
    }
  ],
  'runway-gen4-image': [
    { 
      value: 'gen4_image', 
      text: 'Gen-4 Image', 
      formats: [
        '16:9', '9:16', '1:1', '4:3', '3:4', '21:9'
      ], 
      quality: ['720p', '1080p'], 
      count: [1], 
      maxFiles: 3, // Поддерживает до 3 reference images
      supportsImageToImage: true,
      supportsReferenceImages: true, // Поддержка reference images с тегами
      description: 'До 3 референсных фото одновременно — переносит персонажей и объекты в разные сцены, сохраняя их идентичность. Сильна в консистентности при смене окружения и освещения.',
      descriptionKey: 'models.runwayGen4Image.description'
    }
  ],
  'runway-gen4-image-turbo': [
    { 
      value: 'gen4_image_turbo', 
      text: 'Gen-4 Image Turbo', 
      formats: [
        '16:9', '9:16', '1:1', '4:3', '3:4', '21:9'
      ], 
      quality: ['720p', '1080p'], 
      count: [1], 
      maxFiles: 3, // Требует минимум 1, поддерживает до 3 reference images
      supportsImageToImage: true,
      supportsReferenceImages: true, // Поддержка reference images с тегами
      requiresReferenceImage: true, // ТРЕБУЕТ минимум 1 reference image
      description: 'Быстрая версия Gen-4, заточенная под работу с референсом. Нужен хотя бы один опорный снимок — зато результат появляется быстро. Хорошо для итераций.',
      descriptionKey: 'models.runwayGen4ImageTurbo.description'
    }
  ],
  'reve': [
    {
      value: 'reve',
      text: 'Reve',
      formats: ['1:1', '16:9', '9:16', '3:2', '2:3', '4:3', '3:4'],
      quality: ['standard'], // Только одно качество
      count: [1], // Пока только 1 изображение за раз
      maxFiles: 4, // Максимум 4 изображения для Remix режима
      supportsImageToImage: true, // Поддерживает image-to-image (Edit и Remix)
      supportsReferenceImages: true, // Поддержка reference images (Remix с тегами <img>N</img>)
      requiresReferenceImage: false, // НЕ требует (может работать без изображений - Create режим)
      description: 'Три режима: Create — с нуля, Edit — точечные правки, Remix — художественная переработка. Режим определяется автоматически по числу загруженных фото. Сильна в точечном редактировании.',
      descriptionKey: 'models.reve.description'
    }
  ],
  'kling-v2-1': [
    {
      value: 'kling-v2-1',
      text: 'Kling 2.1',
      formats: ['1:1', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '21:9'],
      quality: ['1k', '2k'], // Разрешение: 1k или 2k
      count: [1, 2, 3, 4], // Количество изображений за раз
      maxFiles: 0, // НЕ поддерживает входные изображения
      supportsImageToImage: false, // НЕ поддерживает image-to-image
      requiresReferenceImage: false, // Только text-to-image
      description: 'Надёжная text-to-image без лишних настроек — стабильные результаты в 1K и 2K, до 4 изображений за раз. Хороший выбор когда нужен предсказуемый результат.',
      descriptionKey: 'models.klingV21.description'
    }
  ],
  'kling-o1': [
    {
      value: 'kling-o1',
      text: 'Kling O1',
      formats: ['auto', '1:1', '4:3', '3:4', '3:2', '2:3', '16:9', '9:16', '21:9'],
      quality: ['1k', '2k'], // Разрешение: 1k или 2k
      count: [1, 2, 3, 4], // 1-4 изображений (batch доступен от Basic подписки)
      maxFiles: 1, // Поддерживает 0-1 входное изображение
      supportsImageToImage: true, // Поддерживает text-to-image И image-to-image
      requiresReferenceImage: false, // Изображение опционально
      requiredTier: 'free', // Модель доступна на Free
      batchRequiredTier: 'basic', // Batch (count > 1) доступен только от Basic
      description: 'Работает с референсным фото — сохраняет стиль, пропорции и детали объекта при генерации. Унифицированная мультимодальная архитектура для точного контроля результата.',
      descriptionKey: 'models.klingO1.description'
    }
  ],
  'flux-2-max': [
    {
      value: 'flux-2-max',
      text: 'Flux 2 Max',
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
      quality: ['1K', '2K'],
      count: [1],
      maxFiles: 8, // До 8 референсных изображений
      supportsImageToImage: true,
      requiresReferenceImage: false,
      requiredTier: 'free',
      supportsWorldKnowledge: true, // Grounding Search — поиск актуальной информации
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Высшее качество от Black Forest Labs — grounding search для актуальных данных, до 8 референсов, точный hex-цвет. Лучший выбор для финальных ассетов и сложных сцен.',
      descriptionKey: 'models.flux2Max.description',
      badge: 'top'
    }
  ],
  'flux-2-pro': [
    {
      value: 'flux-2-pro',
      text: 'Flux 2 Pro',
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
      quality: ['1K', '2K'],
      count: [1],
      maxFiles: 8, // До 8 референсных изображений
      supportsImageToImage: true,
      requiresReferenceImage: false,
      requiredTier: 'free',
      supportsColorPalette: true,
      supportsElements: true,
      description: 'Продакшн-модель от Black Forest Labs — баланс скорости и качества, до 8 референсов, точный hex-цвет. Отличный выбор для масштабных задач.',
      descriptionKey: 'models.flux2Pro.description'
    }
  ],
  'flux-2-flex': [
    {
      value: 'flux-2-flex',
      text: 'Flux 2 Flex',
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
      quality: ['1K', '2K'],
      count: [1],
      maxFiles: 8, // До 8 референсных изображений
      supportsImageToImage: true,
      requiresReferenceImage: false,
      requiredTier: 'free',
      supportsColorPalette: true,
      description: 'Flex-версия с тонким контролем: настраиваемые steps и guidance для точной калибровки результата. До 8 референсов, лучшая типографика в линейке FLUX.',
      descriptionKey: 'models.flux2Flex.description'
    }
  ],
  'flux-2-klein-9b': [
    {
      value: 'flux-2-klein-9b',
      text: 'Flux 2 Klein',
      formats: ['1:1', '4:3', '3:4', '16:9', '9:16', '3:2', '2:3', '21:9'],
      quality: ['1K', '2K'],
      count: [1],
      maxFiles: 4, // До 4 референсных изображений
      supportsImageToImage: true,
      requiresReferenceImage: false,
      requiredTier: 'free',
      supportsColorPalette: true,
      description: 'Суб-секундная генерация от Black Forest Labs — самая быстрая модель семейства FLUX.2 с поддержкой до 4 референсов. Идеальна для итераций и высоких объёмов.',
      descriptionKey: 'models.flux2Klein9b.description',
      badge: 'fast'
    }
  ],
  'recraftv4': [
    {
      value: 'recraftv4',
      text: 'Recraft V4',
      formats: ['1:1', '16:9', '9:16', '3:2', '2:3', '4:3', '3:4', '21:9', '9:21'],
      quality: ['1K', '2K'], // 1K = V4 1MP, 2K = V4 Pro 4MP
      count: [1], // Количество скрыто — 1 за раз
      maxFiles: 0, // НЕ поддерживает входные изображения
      supportsImageToImage: false, // Только text-to-image
      supportsVector: true, // Поддержка SVG vector mode
      supportsColorPalette: true,
      requiresReferenceImage: false,
      requiredTier: 'free', // Доступна на Free тарифе
      badge: 'top',
      description: 'Единственная модель с настоящим нативным SVG — генерирует редактируемые векторные пути, а не трассировку растра. Результат сразу открывается в Figma или Illustrator.',
      descriptionKey: 'models.recraftV4.description'
    }
  ],
  'midjourney-v7': [
    {
      value: 'midjourney-v7',
      text: 'Midjourney v7',
      formats: ['1:1', '16:9', '9:16', '4:3', '3:4', '2:3', '3:2', '9:21', '21:9'],
      quality: ['standard'],
      count: [4],
      maxFiles: 1, // 1 файл для Style Reference (sref)
      supportsImageToImage: false,
      requiresReferenceImage: false,
      requiredTier: 'free',
      badge: 'top',
      fixedBatchCount: 4,
      supportsStylize: true,
      midjourneyVersion: '7',
      supportsAdvancedSettings: true,
      supportsReferenceImages: true,
      description: 'Последняя версия Midjourney — улучшенная детализация, лучшее следование промпту и более реалистичные текстуры. Всегда генерирует 4 варианта за запрос.',
      descriptionKey: 'models.midjourneyV7.description'
    }
  ],
  'midjourney-v6.1': [
    {
      value: 'midjourney-v6.1',
      text: 'Midjourney v6.1',
      formats: ['1:1', '16:9', '9:16', '4:3', '3:4', '2:3', '3:2', '9:21', '21:9'],
      quality: ['standard'],
      count: [4],
      maxFiles: 1, // 1 файл для Style Reference (sref)
      supportsImageToImage: false,
      requiresReferenceImage: false,
      requiredTier: 'free',
      fixedBatchCount: 4,
      supportsStylize: true,
      midjourneyVersion: '6.1',
      supportsAdvancedSettings: true,
      supportsReferenceImages: true,
      description: 'Обновлённая v6 с улучшенной когерентностью и детализацией. Хороший баланс между художественностью и точностью. 4 варианта за запрос.',
      descriptionKey: 'models.midjourneyV61.description'
    }
  ],
  'midjourney-v6': [
    {
      value: 'midjourney-v6',
      text: 'Midjourney v6',
      formats: ['1:1', '16:9', '9:16', '4:3', '3:4', '2:3', '3:2', '9:21', '21:9'],
      quality: ['standard'],
      count: [4],
      maxFiles: 1, // 1 файл для Style Reference (sref)
      supportsImageToImage: false,
      requiresReferenceImage: false,
      requiredTier: 'free',
      fixedBatchCount: 4,
      supportsStylize: true,
      midjourneyVersion: '6',
      supportsAdvancedSettings: true,
      supportsReferenceImages: true,
      description: 'Классическая версия с узнаваемым художественным стилем Midjourney. Проверенная стабильность и предсказуемый результат. 4 варианта за запрос.',
      descriptionKey: 'models.midjourneyV6.description'
    }
  ],
  'z-image-turbo': [
    {
      value: 'z-image-turbo',
      text: 'Z-Image Turbo',
      formats: ['1:1', '2:3', '3:2', '3:4', '4:3', '9:16', '16:9'],
      quality: ['0.5K', '1K', '2K'],
      count: [1],
      maxFiles: 0,
      supportsImageToImage: false,
      requiresReferenceImage: false,
      requiredTier: 'free',
      description: 'Лёгкая и быстрая text-to-image от Alibaba Cloud — рендерит текст на китайском и английском, поддерживает гибкие разрешения. Хороша для быстрых итераций.',
      descriptionKey: 'models.zImageTurbo.description'
    }
  ]
};

// Типы для видео моделей (реэкспорт из store)
export type { VideoModelConfig, VideoProviderConfig, VideoModelsMap } from '../stores/usePricingStore';

/**
 * @deprecated Proxy к динамическим данным из store.
 * Актуальные данные приходят с бэкенда через usePricingStore.videoModels.
 * Единый источник правды: pricing/video/registry.js
 */
import { getVideoModelsSync } from '../stores/usePricingStore';
import type { VideoModelsMap } from '../stores/usePricingStore';

export const VIDEO_MODELS_CONFIG: Record<string, import('../stores/usePricingStore').VideoProviderConfig> = new Proxy(
  {} as Record<string, import('../stores/usePricingStore').VideoProviderConfig>,
  {
    get(_target, prop: string) {
      const models = getVideoModelsSync();
      return (models || {} as VideoModelsMap)[prop];
    },
    ownKeys() {
      const models = getVideoModelsSync();
      return Object.keys(models || {});
    },
    getOwnPropertyDescriptor(_target, prop: string) {
      const models = getVideoModelsSync();
      const data = (models || {} as VideoModelsMap);
      if (prop in data) {
        return { enumerable: true, configurable: true, value: data[prop] };
      }
      return undefined;
    },
    has(_target, prop: string) {
      const models = getVideoModelsSync();
      return prop in (models || {});
    }
  }
);

// Дефолтные значения
export const DEFAULT_CHAT_PROVIDER = 'gemini';
export const DEFAULT_CHAT_MODEL = 'gemini-3.1-flash-lite-preview';
export const DEFAULT_IMAGE_PROVIDER = 'nano-banana-2';
export const DEFAULT_IMAGE_MODEL = 'gemini-3.1-flash-image-preview';
export const DEFAULT_VIDEO_PROVIDER = 'kling';
export const DEFAULT_VIDEO_MODEL = 'kling-v2-5-turbo';


